
<template>
  <div>

    <ClientEditClientCreditDialog v-if="is_editing" @update="(data) => this.$emit('updateCredit', data)" @close="is_editing = false"></ClientEditClientCreditDialog>
    <ClientEditScoreAndSocialDate v-if="is_editing_score" @update="(data) =>  this.$emit('updateScore', data)" @close="is_editing_score = false" :client="client"></ClientEditScoreAndSocialDate>
    <ClientEditEconomicGroupDialog v-if="is_editing_group" :value="is_editing_group" @input="is_editing_group = $event" :client="client" :economic-groups="economicGroups" @update="handleEconomicGroupUpdate" @close="is_editing_group = false"></ClientEditEconomicGroupDialog>

    <v-row v-if="client.data.attributes.credits" class="px-6 mt-4 pb-3">
      <v-col cols="12" class="pa-0">
        <ProfileFinancialAndPayments></ProfileFinancialAndPayments>
      </v-col>
      <v-col cols="12" class="d-flex mt-3 pb-0">
        <ClientBlockHistory class="mr-3"></ClientBlockHistory>
        <ClientCreditHistory ></ClientCreditHistory>
      </v-col>
      <v-col cols='12'>
        <ClientBlockAlert v-on="$listeners" :client="client" :client_credit="client.data.attributes.credits"></ClientBlockAlert>
      </v-col>

      <v-col cols='12' class="pb-6 pt-0">
        <v-expansion-panels  class="border-white" >
          <v-expansion-panel  class="border-white" >
            <v-expansion-panel-header class="red--text font-weight-bold">Crédito do cliente</v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row>
                <v-col class="d-flex justify-space-between pt-0" cols="12">
                  <v-spacer></v-spacer>
                  <f-btn v-if="user_allowed && canBlock" edit small class="ml-2" @click="is_editing = true"></f-btn>
                </v-col>
                <v-col cols='12' sm='6' md='4' class="py-0" v-if="client.data.attributes.credits.data.attributes.limit != null">
                  <v-text-field
                    :value="client.data.attributes.credits.data.attributes.limit.replace(/\d(?=(\d{3})+\.)/g, '$&,')"
                    label="Total de Crédito (R$)" readonly
                  ></v-text-field>
                </v-col>
                <v-col cols='12' sm='6' md='4' class="py-0" v-if="client.data.attributes.credits.data.attributes.original_limit != null">
                  <v-text-field
                    :value="client.data.attributes.credits.data.attributes.original_limit.replace(/\d(?=(\d{3})+\.)/g, '$&,')"
                    label="Crédito Original (R$)" readonly
                  ></v-text-field>
                </v-col>
                <v-col cols='12' sm='6' md='4' class="py-0" v-if="client.data.attributes.credits.data.attributes.bonus != null">
                  <v-text-field
                    :value="client.data.attributes.credits.data.attributes.bonus.replace(/\d(?=(\d{3})+\.)/g, '$&,')"
                    label="Bonus (R$)" readonly
                  ></v-text-field>
                </v-col>
                <v-col cols='12' sm='6' md='4' class="py-0" v-if="client.data.attributes.credits.data.attributes.blockingTime != null">
                  <v-text-field 
                    :value="client.data.attributes.credits.data.attributes.blockingTime"
                    label="Tempo para Bloqueio" 
                    readonly
                  ></v-text-field>
                </v-col>
                <v-col cols='12' class="py-0">
                  <v-textarea 
                    :rows="2"
                    label="Comentários" 
                    :value="client.data.attributes.credits.data.attributes.comment"
                    readonly
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel  class="border-white" >
            <v-expansion-panel-header class="red--text font-weight-bold">Informações cadastrais</v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row>
                <v-col class="d-flex justify-space-between pt-0" cols="12">
                  <v-spacer></v-spacer>
                  <f-btn v-if="user_allowed && canBlock" edit small class="ml-2" @click="is_editing_score = true"></f-btn>
                </v-col>
                <v-col cols='12' class="py-0" >
                  <v-text-field :value="$moment(client.data.attributes.created_at).format('DD/MM/YYYY')" label="Data de cadastro do cliente no sistema" readonly></v-text-field>
                </v-col>
                <v-col cols='12' class="py-0" >
                  <v-text-field :value="$moment(client.data.attributes.social_open_date).format('DD/MM/YYYY')" label="Data de abertura(contrato social)" readonly></v-text-field>
                </v-col>
                <v-col cols='12' class="py-0" >
                  <v-text-field :value="client.data.attributes.spc_score" label="Score" number readonly></v-text-field>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel class="border-white">
            <v-expansion-panel-header class="red--text font-weight-bold">Grupo econômico</v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row>
                <v-col class="d-flex justify-space-between pt-0" cols="12">
                  <div class="subtitle-2">
                    <span>Grupo atual: </span>
                    <strong>{{ currentEconomicGroupName || 'Nenhum grupo selecionado' }}</strong>
                  </div>
                  <v-spacer></v-spacer>
                  <f-btn v-if="user_allowed && canBlock" edit small class="ml-2" @click="is_editing_group = true"></f-btn>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>

          <v-expansion-panel  class="border-white" >
            <v-expansion-panel-header class="red--text font-weight-bold">SPC</v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-container grid-list-lg>
                <v-row justify="space-around">
                  <v-col cols='12' class="pb-0 px-0">
                    <v-alert 
                      :value="true" 
                      :type="client_consult_date.type"
                    > 
                      <v-row align="center">
                        {{ client_consult_date.text }}
                      </v-row>
                    </v-alert>

                    <!-- <v-alert 
                      :value="true" 
                      :type="
                        client.data.attributes.status_name.includes('Act') ? 'success' :
                        client.data.attributes.status_name.includes('Ina') ? 'warning' :
                        client.data.attributes.status_name.includes('Exc') ? 'error' : 'error'
                      "
                    > 
                      <v-row align="center">
                        {{ifLocal_status_map.client_status}}
                        <v-spacer></v-spacer>
                        <v-btn color="white"  rounded class="black--text"
                          v-if="canBlock && client.data.attributes.status_name.includes('SPC')">
                          <v-icon left>mdi-account-lock-open</v-icon>
                          Desbloquear
                        </v-btn>
                      </v-row>
                    </v-alert> -->
                  </v-col>

                  <template>
                    <v-btn 
                      class="mb-3" 
                      color="primary" 
                      block 
                      v-if="client.data.attributes.attached_file_url ? client.data.attributes.attached_file_url.substr(-3) == 'pdf' : false" 
                      :href="`${client.data.attributes.attached_file_url}`" 
                      target="_blank"
                    ><v-icon>mdi-download</v-icon>Baixar arquivo</v-btn>
                    <pdf 
                      v-if="pdf" 
                      :src="pdf" 
                      width="500"
                      height="600"
                      style="width: 700px"
                    ></pdf>
                    <v-img 
                      v-if="client.data.attributes.attached_file_url && client.data.attributes.attached_file_url.substr(-3) != 'pdf'"
                      :src="client.data.attributes.attached_file_url" 
                      contain
                    ></v-img>
                  </template>
                  <template v-if="!client.data.attributes.attached_file_url">
                    <v-alert type="info" :value="true">Não possui documento de consulta ao SPC</v-alert>
                  </template>
                  <template>

                    <v-col cols="12">
                      <FileAttachment 
                        ref="file_attachment" 
                        :attachment_text="{add:'Adicionar anexo do SPC', change: 'Alterar anexo do SPC', look:'Visualizar Anexo do SPC'}"
                        :update_infos="{MODEL: 'Client', id: $route.params.id}" 
                        :attached_file_url="client.data.attributes.attached_file_url" 
                        :is_creating="!$route.params.id" 
                        @newFileUrl="handleNewFileUrl"
                      ></FileAttachment>
                    </v-col>
                  </template>
                </v-row>

              </v-container>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>

    </v-row>

    <h3 v-if="!client.data.attributes.credits">Não possui crédito. Favor entrar em contato com seu Gerente/Diretor</h3>

  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import pdf from 'vue-pdf'
import Api from '@/api/index'

export default {
  name: 'ClientCredit',
  components: {
    ClientEditClientCreditDialog: () => import("@/_backoffice/_registrations/components/client/show/edit/ClientEditClientCreditDialog.vue"),
    ClientEditScoreAndSocialDate: () => import("@/_backoffice/_registrations/components/client/show/edit/ClientEditScoreAndSocialDate.vue"),
    ClientEditEconomicGroupDialog: () => import("@/_backoffice/_registrations/components/client/show/edit/ClientEditEconomicGroupDialog.vue"),
    ClientBlockHistory: () => import("@/_backoffice/_registrations/components/client/client_historic/ClientBlockHistory.vue"),
    ClientCreditHistory: () => import("@/_backoffice/_registrations/components/client/client_historic/ClientCreditHistory.vue"),
    ProfileFinancialAndPayments: () => import("@/_backoffice/_registrations/components/client/show/financial/ProfileFinancialAndPayments.vue"),
    ClientBlockAlert: () => import("@/_backoffice/_registrations/components/shared/client_block/ClientBlockAlert.vue"),
    FileAttachment: () => import('@/components/shared/FileAttachment.vue'),
    pdf
  },
  props: {
    client: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      is_editing: false,
      is_editing_score: false,
      is_editing_group: false,
      local_status_map: {
        'Active': { client_status: 'Cliente Regular' }, 
        'Inactive': { client_status: 'Cliente inativo, nao compra ha mais de 1 mês' }, 
        'Client blocked with invalid SPC': { client_status: 'Cadastro desatualizado'}, 
        'Excluded': { client_status: 'Cliente excluído'}, 
      },
      pdf: null,
      economicGroups: [],
      loadingEconomicGroups: false,
    }
  },
  methods: {
    handleEconomicGroupUpdate(data) {
      this.client.data.attributes.economic_group_id = data.economic_group_id
    },
    handleNewFileUrl(data){
      this.client.data.attributes.attached_file_url = data.url
      this.fetchPdfUrl()
    },
    async fetchPdfUrl(){
      if(this.client?.data?.attributes?.attached_file_url?.substr(-3) == 'pdf'){
        let pdfUrl = this.client.data.attributes.attached_file_url
        try {
          let response = await fetch(pdfUrl);
          if (!response.ok) throw new Error("Erro ao baixar o PDF");
          //let blob = await response.blob();
          this.pdf = response.url //URL.createObjectURL(blob);
        } catch (error) {
          console.error("Erro ao carregar o PDF:", error);
        }
      }
    },
    loadEconomicGroups() {
      this.loadingEconomicGroups = true
      Api.EconomicGroup.index().then((res)=>{
        this.economicGroups = res.data.data || []
      }).catch((err)=>{
        console.error("Erro ao carregar os grupos econômicos:", err)
        this.economicGroups = []
      }).finally(()=>{
        this.loadingEconomicGroups = false
      })
    },
  },
  computed: {
    client_consult_date(){
      if(this.client.data.attributes.spc_consult_date){
        return {
          text: 'Última consulta ao SPC em ' + this.$moment(this.client.data.attributes.spc_consult_date).format('DD/MM/YYYY [às] HH:mm') + ', ' +(this.$moment(this.client.data.attributes.spc_consult_date).fromNow() + '.'),
          type: this.$moment().diff(this.$moment(this.client.data.attributes.spc_consult_date), 'days') < 90 ? 'info' : 'error'
        }
      }else{
       return {
        text: 'Nunca foi realizada consulta ao SPC',
        type: 'warning'
       }
      }
      
    },
    user_allowed() {
      return this.isManager() || this.isDirector() || this.isFinancial() || this.isAnalyst() || this.isSalesExecutive() || this.isCreditAnalyst()
    },
    canBlock() {
      return this.isSalesExecutive() || this.isDirector() || this.isCreditAnalyst()
    },
    ifLocal_status_map(){
      if(this.client.data.attributes.status_name in this.local_status_map){
        return this.local_status_map[this.client.data.attributes.status_name]
      }else{
        return { client_status: ''}
      }
    },
    ...mapState({
      allStatuses: state => state.Status.allStatuses,
    }),
    currentEconomicGroupName() {
      let currentId = this.client?.data?.attributes?.economic_group_id
      if (!currentId || !this.economicGroups.length) return null
      let found = this.economicGroups.find(g => Number(g.id) === Number(currentId))
      return found?.attributes?.name || null
    },
  },
  mounted () {
    this.fetchPdfUrl()
    this.loadEconomicGroups()
  },
  
}
</script>